module.exports = __webpack_public_path__ + "img/shellfish.fb4a0e9f.png";